import { render } from "./ResultsBox.vue?vue&type=template&id=7137e354"
import script from "./ResultsBox.vue?vue&type=script&lang=js"
export * from "./ResultsBox.vue?vue&type=script&lang=js"

import "./ResultsBox.vue?vue&type=style&index=0&id=7137e354&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__